import { Component, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SimpleInputModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'iw-card-personal-form',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SimpleInputModule,
    TranslateModule,
  ],
  templateUrl: './card-personal-form.component.html',
  styleUrl: './card-personal-form.component.scss',
})
export class CardPersonalFormComponent {
  form = input<FormGroup>();

  readonly cardNumberErrors: Record<string, string> = {
    cardInvalid: 'withdrawal.cardPersonal.cardNumber.error.format',
  };
}
